import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Clapperboard, Play, Heart, MessageCircle } from "lucide-react";
import { Card } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const num = (v) => Number(v || 0).toLocaleString("pt-BR");

/** Vertical-video grid for a profile. Tapping a tile opens the Reels player starting at that video. */
export default function ProfileReelsTab({ userId, isMe }) {
  const navigate = useNavigate();
  const [reels, setReels] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/users/${userId}/reels`).then((r) => { if (alive) setReels(r.data || []); }).catch(() => { if (alive) setReels([]); });
    return () => { alive = false; };
  }, [userId]);

  if (reels === null) return <p className="text-sm text-muted-foreground py-6 text-center" data-testid="profile-reels-loading">Carregando reels...</p>;
  if (reels.length === 0) {
    return (
      <Card className="p-8 text-center text-sm text-muted-foreground" data-testid="profile-reels-empty">
        <Clapperboard className="w-10 h-10 mx-auto opacity-30 mb-2" />
        {isMe ? "Você ainda não publicou vídeos. Crie um Reel pelo botão Criar." : "Este perfil ainda não publicou vídeos."}
      </Card>
    );
  }
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-1.5 sm:gap-2" data-testid="profile-reels-grid">
      {reels.map((p) => (
        <button
          key={p.post_id}
          type="button"
          onClick={() => navigate(`/reels?start=${p.post_id}`)}
          data-testid={`profile-reel-${p.post_id}`}
          className="relative aspect-[9/16] rounded-xl overflow-hidden bg-black group text-left"
          aria-label={p.content ? p.content.slice(0, 60) : "Reel"}
        >
          {p.cover_url
            ? <img src={p.cover_url} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
            : <video src={p.video_url} muted playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <Play className="absolute top-2 right-2 w-4 h-4 text-white drop-shadow" fill="currentColor" />
          {p.is_reel && <span className="absolute top-2 left-2 text-[9px] font-bold uppercase tracking-widest text-white bg-pink-600/90 rounded-full px-1.5 py-0.5">Reel</span>}
          <div className="absolute bottom-1.5 left-2 right-2 flex items-center gap-2 text-white text-[11px] font-semibold drop-shadow">
            <span className="inline-flex items-center gap-0.5"><Heart className="w-3 h-3" fill="currentColor" /> {num(p.likes_count)}</span>
            <span className="inline-flex items-center gap-0.5"><MessageCircle className="w-3 h-3" /> {num(p.comments_count)}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
